import React, { useState } from "react";
import { Link } from "react-router-dom";

//Images
import rr from "../../Reviews/images/rr-testimonial.png";
import sl from "../../Reviews/images/sl-testimonial.png";
import sb from "../../Reviews/images/sb-testimonial.png";

const Reviews = () => {
  const [rev1, setrev1] = useState(false);
  const [rev2, setrev2] = useState(false);
  const [rev3, setrev3] = useState(false);

  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 panel-reviews">
        <h2 className="text-center text-uppercase text-blue mb-4">
          What our customers are saying
        </h2>
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row justify-content-around review-list">
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item">
                <div className="row">
                  <div className="col-3">
                    <img src={rr} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      R.R.
                      <br />
                      Studio City, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      “Every once in a while I come across a contractor whose
                      standards are exceptional on all levels. Pacific
                      Pavingstone is one of those contractors! They recently
                      installed an 1,100 sq ft paver stone driveway, numerous
                      cantilevered concrete steps, board formed concrete planter
                      walls and landscaping that is of the highest quality and
                      that we just LOVE! Furthermore,
                      {!rev1 ? (
                        "..."
                      ) : (
                        <>
                          Trent, John, Luis and their entire staff were always a
                          pleasure to work with and the entire experience was
                          easy and stress-free too! If you want a contractor
                          that is professional, does outstanding quality work
                          and one that you will not lose any sleep over, Pacific
                          Pavingstone is the one for you!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev1(!rev1)}>
                      {rev1 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item tablet-hidden">
                <div className="row">
                  <div className="col-3">
                    <img src={sl} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      S.L.
                      <br />
                      Calabasas, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      “This company is one of the best and most ethical company
                      I have ever worked with. I have had extensive remodeling
                      at my house. No one I mean no one has ever been more
                      responsible and punctual. They finished my driveway a week
                      ahead of schedule. I'm very impressed. Even after the job
                      was done they contacted me and wanted to make sure we were
                      happy. The crew and supervisor
                      {!rev2 ? (
                        "..."
                      ) : (
                        <>
                          Craig Jorge Onicemo, Hugo and Javier are all fantastic
                          and professional group. Trust me if need any work done
                          these guys are very legit and impressive. You would
                          not regret it. Their work is very clean and design is
                          amazing. Thank you Pacific paving Stone, GREAT JOB
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev2(!rev2)}>
                      {rev2 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-10 col-md-8 col-lg-3 mt-3 mt-lg-0 review-item tablet-hidden">
                <div className="row">
                  <div className="col-3">
                    <img src={sb} alt="Profile" />
                  </div>
                  <div className="col-9 text-left">
                    <p>
                      S.B.
                      <br />
                      S.B. Pasadena, CA
                    </p>
                  </div>
                </div>
                <div className="row testimony mt-3">
                  <div className="col-12">
                    <p>
                      I highly recommend Pacific Pavingstone for any paving job.
                      They recently added a beautiful patio of pavers to our
                      backyard and we couldn't be happier with the result. Craig
                      came out to give us an estimate for our small job and
                      spent a considerable amount of time with us, going over
                      all our options. His team even dropped off some sample
                      pavers when we couldn't decide
                      {!rev3 ? (
                        "..."
                      ) : (
                        <>
                          what color to go with so we could see it in-place.
                          Onecimo and his crew were awesome and made sure we
                          were happy as the job progressed. No detail was too
                          small for them to take the time to do it right and
                          make sure it looked good. They left the job site clean
                          at the end of every day and were very professional.
                          They also started and finished the job in the exact
                          timeframe they said they would.
                          <br />
                          <br />
                          Like a few others mentioned, they weren't the cheapest
                          estimate but you get what you pay for. This is a good
                          company that was easy to work with and installed a
                          quality product. Highly recommend!
                        </>
                      )}{" "}
                      "
                    </p>
                    <button onClick={() => setrev3(!rev3)}>
                      {rev3 ? "Show Less" : "Continue reading"}
                    </button>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-1">
          <div className="col-lg-3 text-center">
            <Link to="/reviews">
              <button className="button-main reviews-button transition-3">
                View Our Customer Reviews
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
